const IGNORED_TEXT_PARENTS = 'select, option, optgroup, input, textarea, script, style'

function getCandidateText(candidate: Element) {
  if (!(candidate instanceof HTMLElement)) {
    return ''
  }

  const walker = document.createTreeWalker(candidate, NodeFilter.SHOW_TEXT)

  let node = walker.nextNode()
  while (node) {
    if (node.parentElement?.closest(IGNORED_TEXT_PARENTS)) {
      node = walker.nextNode()
      continue
    }

    const text = node?.textContent?.replace(/\s+/g, ' ').trim()
    if (text) {
      return text
    }

    node = walker.nextNode()
  }

  return ''
}

export function findNearestText(element: HTMLElement) {
  let current: HTMLElement | null = element

  while (current) {
    for (const candidate of [current, current.previousElementSibling, current.nextElementSibling]) {
      if (candidate) {
        const text = getCandidateText(candidate)
        if (text) {
          return text
        }
      }
    }

    current = current.parentElement
  }

  return ''
}
